
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

var script = {
  name: 'PendoApp',
  props: {
    topbarHeight: {
      type: [Number, String],
      default: 0
    },
    footerHeight: {
      type: [Number, String],
      default: 0
    },
    sidebarWidth: {
      type: [Number, String],
      default: 0
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    pageBackgroundColor: {
      type: String,
      default: '#F8F8F9'
    }
  },

  provide() {
    return {
      $app: this
    };
  },

  data() {
    return {
      tabs: false
    };
  },

  methods: {
    updateProperty(property, value) {
      this[property] = value;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    style: {
      background: _vm.backgroundColor,
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
      overflow: 'hidden'
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-app.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoApp = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoApp;
